import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ReportContext, ReportDefinition, ReportSessionStatus, StandardReportRow } from './report.models';

@Injectable({ providedIn: 'root' })
export class ReportApiService {
  async loadStandardReport(
    definition: ReportDefinition,
    context: ReportContext,
    systemUser: string,
    session: string,
  ): Promise<StandardReportRow[] | ReportSessionStatus> {
    const credentials = { iSystemUser: systemUser, strSession: session };
    const response = definition.requestMode === 'session-body'
      ? await axios.post(definition.endpoint!, credentials)
      : definition.requestMode === 'date-body'
        ? await axios.post(definition.endpoint!, { strSDate: context.startDate, strEDate: context.endDate, ...credentials })
        : await axios.post(`${definition.endpoint}?vstrSDate=${context.startDate}&vstrUnitID=&vstrEDate=${context.endDate}&iSystemUser=${systemUser}&strSession=${encodeURIComponent(session)}`);
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data;
    if (data?.ISSessionExpired || data?.ISessionExpired) return data;
    throw new Error('Unexpected report response');
  }
}
